import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { PLOT_DATA_LOADED, PLOT_DATA_LOADING, PLOT_DATA_ERROR } from 'redux/actionTypes/componentConfig';
import handleError from 'utils/http/handleError';
import fetchWork from 'utils/work/fetchWork';
import browserDownloader from 'utils/work/downloaders/browserDownloader';
var downloadNormalizedMatrix = function downloadNormalizedMatrix(plotUuid, experimentId, subsetBy) {
  var optionals = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _optionals$onResultSo, onResultSourceChange, body, fileName, resultSource, errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _optionals$onResultSo = optionals.onResultSourceChange, onResultSourceChange = _optionals$onResultSo === void 0 ? function () {} : _optionals$onResultSo;
            _context.prev = 1;
            body = {
              name: 'GetNormalizedExpression',
              subsetBy: subsetBy
            };
            dispatch({
              type: PLOT_DATA_LOADING,
              payload: {
                plotUuid: plotUuid
              }
            });
            fileName = 'NormalizedExpression.csv.gz';
            resultSource = 'worker';
            _context.next = 8;
            return fetchWork(experimentId, body, getState, dispatch, {
              fileName: fileName,
              onCachedResultHit: function onCachedResultHit() {
                resultSource = 'cache';
                onResultSourceChange('cache');
              },
              onWorkRequestSent: function onWorkRequestSent() {
                resultSource = 'worker';
                onResultSourceChange('worker');
              }
            }, browserDownloader, function (data) {
              return data;
            });
          case 8:
            dispatch({
              type: PLOT_DATA_LOADED,
              payload: {
                plotUuid: plotUuid,
                plotData: null
              }
            });
            return _context.abrupt("return", {
              resultSource: resultSource
            });
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            errorMessage = handleError(_context.t0, null, false);
            dispatch({
              type: PLOT_DATA_ERROR,
              payload: {
                plotUuid: plotUuid,
                error: errorMessage
              }
            });
            onResultSourceChange(null);
            return _context.abrupt("return", {
              resultSource: null
            });
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 12]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default downloadNormalizedMatrix;